import RangeSlider from '../util/RangeSlider';
import autoComplete from '@tarekraafat/autocomplete.js';
const adminAjax = window.adminAjax;
let result = [];
let zips = [];

export default {
  init() {

    // Autocomplete
    if ($('#autoComplete').length > 0) {

      let lang = $('#autoComplete').data('lang');
      if (lang == 'en') {
        lang = 'fr';
      }

      // Tous les codes postaux de Belgique
      $.getJSON('/wp-content/themes/everone/resources/data/zips.json', function (data) {
        $.each(data, function (key, val) {
          zips.push({
            'name': val.zip + ' - ' + val[lang],
            'city': val[lang],
            'zip': val.zip,
          });
        })
      })

      // Ceux réellement utilisés
      $.ajax({
        type: 'POST',
        url: adminAjax.ajaxurl,
        data: {
          security: adminAjax.security,
          action: 'get_zip_codes',
        },
        beforeSend: function () {
        },
        success: function (data) {
          callback(data);
        },
      });



    }

  },
  finalize() {
    const sliders = document.querySelectorAll('.js-range');
    sliders.forEach(element => {
      RangeSlider.init(element);
    });

    if ($('#results').length > 0 && $('.js-filters').length > 0) {
      $('body').on('change', '.js-filters-field', filterListing);
      $('body').on('submit', '.js-filters', filterListing);
      $('body').on('click', '.js-loadmore-estates', filterListing)
    }

  },
};

function callback(data) {
  let autoCompleteJS = null;

  const estateZips = Object.values(data);

  result = zips.filter((zip) => {
    return estateZips.indexOf(zip.zip) >= 0;
  });

  console.log(result);

  $('.js-autocomplete').removeAttr('disabled');
  const placeholder = $('.js-autocomplete').data('placeholder');
  const noResultMsg = $('.js-autocomplete').data('noresult');
  autoCompleteJS = new autoComplete({
    placeHolder: placeholder,
    selector: function () { return $('.js-autocomplete').get(0); },
    data: {
      src: result,
      keys: ['name'],
      cache: true,
    },
    threshold: 0,
    resultItem: {
      class: 'px-3 my-3 hover:text-secondary cursor-pointer',
    },
    resultsList: {
      class: 'absolute bg-white shadow w-full rounded-lg',
      element: (list, data) => {
        if (!data.results.length) {
          // Create "No Results" message list element
          const message = document.createElement('div');
          message.setAttribute('class', 'no-result p-2');
          // Add message text content
          message.innerHTML = '<span>' + noResultMsg + '</span>';
          // Add message list element to the list
          list.appendChild(message);
        }
      },
      noResults: true,
    },
    query: (query) => {
      // Split query into array
      const querySplit = query.split(',');
      // Get last query value index
      const lastQuery = querySplit.length - 1;
      // Trim new query
      const newQuery = querySplit[lastQuery].trim();

      return newQuery;
    },
    events: {
      input: {
        focus: () => {
          const inputValue = autoCompleteJS.input.value;
          if (inputValue.length) autoCompleteJS.start();
        },
        selection: (event) => {
          const feedback = event.detail;
          const input = autoCompleteJS.input;
          autoCompleteJS.input.blur();
          // Replace Input value with the selected value
          input.value = feedback.selection.value['zip'];
          $('.js-filters').trigger('submit');
        },
      },
    },
  });
}

function filterListing(e) {
  e.preventDefault();
  const values = $('.js-filters').serialize();
  const page = $(this).data('page') ? $(this).data('page') : 1;

  if ($('#results').length > 0) {
    $.ajax({
      type: 'POST',
      url: adminAjax.ajaxurl,
      data: {
        security: adminAjax.security,
        data: values,
        page: page,
        action: 'filter_estates',
      },
      beforeSend: function () {
        $('#results').addClass('loading');
      },
      success: function (data) {
        $('#results').removeClass('loading');
        if (!$(data).find('.js-loadmore-estates').length > 0) {
          $('.js-loadmore-estates').remove();
        }
        if (page > 1) {
          $('#results .js-estates').append($(data).find('.js-estate'));
          $('#results .js-loadmore-estates').replaceWith($(data).find('.js-loadmore-estates'));
        } else {
          $('#results').html(data);
        }
      },
    });
  }
}
